import React, { useState, useRef } from "react"
import currentExpensesJson from "../../../Configs/JSON/currentExpenses.json"
import "../../../styles/Calculator/CurrentExpenses.less"
import AccurateResult from "./AccurateResult"
import CalculatorStore from "../../../Configs/Store/calculator"
import CalculatorButton from "../../Common/CalculatorButton"
import closeImg from "../../../assets/Calculator/close.svg"
import { observer } from "mobx-react"
import { DataLayerFn } from "../../../Configs/API"

const CurrentExpenses = observer((props) => {
  let [showData, setShowData] = useState(CalculatorStore.showData)
  let inputRef = useRef(null)
  var showResults = true
  let divcontainer = false
  const closeBtn = (e) => {
    setShowData(0)
    CalculatorStore.setShowData(0)
    divcontainer = false
  }

  const HandleChange = (e) => {
    if (CalculatorStore.showData === 0 || showData === 0) {
      setShowData(1)
      CalculatorStore.setShowData(1)
    } else {
      setShowData(0)
      CalculatorStore.setShowData(0)
    }

    if (divcontainer === false) {
      divcontainer = true
    } else {
      divcontainer = false
    }

    CalculatorStore.screenNo === "Scr5" && CalculatorStore.setFifthScreenFlag(true)
    try {
      DataLayerFn("AdditionalExpenses_Clicked", CalculatorStore, "Enter details for more accurate results")
    } catch {}
  }

  const expensesKeypress = (event) => {
    return CalculatorStore.setCurrentChar(event.key)
  }

  return (
    <div className="currentExpensesParentCont" nextscrbutton={props.scrn}>
      <div className="ttl">{currentExpensesJson[props.id].calculatorHeading}</div>
      <div className="current-expenses-container">
        <div className="row">
          <div className="col-12">
            <div className="custom-input-group custom-input-group-lg input-group">
              <div className="input-group-prepend" id="inputGroupPrepend">
                {" "}
                <span className="input-group-text">₹</span>{" "}
              </div>
              <input
                className="form-control"
                type="tel"
                pattern="[0-9]*"
                name="currentExpenses"
                id={CalculatorStore.multipleAmt}
                value={CalculatorStore.multipleAmt}
                key={CalculatorStore.multipleAmt}
                onChange={(e) => props.handlecurrentExpenses(e)}
                onKeyPress={expensesKeypress}
                ref={inputRef}
                autoFocus={inputRef.current === document.activeElement}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="expanding-colm">
        <div className="row">
          <div className="col-md-6 col d-sm-block">
            {!CalculatorStore.errorAmount ? <div className="error">{CalculatorStore.errorAmountMessage}</div> : <div className="inwords">{CalculatorStore.numToWords}</div>}
          </div>
          <div className="col-md-6 col-12 pl-sm-0 d-sm-block">
            <div className="currentExpensesLink" onClick={HandleChange}>
              {currentExpensesJson[props.id].calculatorLink}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="currentExpensesPopup mt-1" nextscrbutton={props.scrn} showData={CalculatorStore.showData}>
              <div className="currentExp-wrap">
                <button type="button" className="close" onClick={closeBtn}>
                  {" "}
                  <img src={closeImg} alt={"close"} />{" "}
                </button>
                <div className="form-row">
                  <AccurateResult
                    handlecurrentExpenses_Accurate={props.handlecurrentExpenses_Accurate}
                    showResults={showResults}
                    id={props}
                    expensesKeypress={expensesKeypress}
                    style={{ display: "none" }}
                  />
                </div>
                <div className="form-row">
                  {!CalculatorStore.fifthScreenFlag && (
                    <CalculatorButton className="popupBtn col-12" title={"Next"} onClick={props.handlenextbutton} scrn={"Scr5"} disabled={CalculatorStore.isDisabled} />
                  )}
                  {CalculatorStore.fifthScreenFlag && (
                    <CalculatorButton className="popupBtn col-12" title={"Next"} onClick={props.handlenextbutton} scrn={"Scr6"} disabled={CalculatorStore.isDisabled} />
                  )}
                </div>
                {CalculatorStore.fifthScreenFlag === true && (
                  <div className="footer">
                    <span className="footerText">Don’t include savings earmarked for other goals such as child education, marriage etc.</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default CurrentExpenses
